'useClient';
import React from 'react';
import { AcceptTermsModal } from '@members/accept-terms/AcceptTermsModal';
import { BrazeModal } from '@members/braze/Modal';
import { LanguageModal } from '@members/modals/LanguageModal/LanguageModal';
import { BookmarkLimitToast } from '@members/notifications/BookmarkLimitToast/BookmarkLimitToast';
import { GlobalFreeTrialBanner } from '@members/notifications/FreeTrialBanner/GlobalBanner';
import FeedNotificationsContainer from '@members/pg-feed/components/FeedNotificationsContainer';
import PrivacyPreferencesModal from '@members/pg-homescreen/components/PrivacyPreferences/PrivacyPreferencesModal';
import { StackModal } from '@members/stacks/Modal/StackModal';
import { TagsModal } from '@members/tags/Modal/TagsModal';
import { TieringModalViewController } from '@members/tiering/view-controllers/TieringModalViewController';

export default function GlobalModals() {
  return (
    <>
      <PrivacyPreferencesModal />
      <GlobalFreeTrialBanner />
      <BookmarkLimitToast />
      <BrazeModal />
      <TagsModal />
      <StackModal />
      <FeedNotificationsContainer />
      <LanguageModal />
      <AcceptTermsModal />
      <TieringModalViewController />
    </>
  );
}
